import sitePaths from "../constants/sitePaths";

const getSvarUtHistorikkCloseUrl = (id) => {
  // pathnameArray[0] is empty string
  const pathnameArray = window.location.pathname.split("/");
  if (
    pathnameArray.length > 3 &&
    pathnameArray[1] === "ileggelser" &&
    pathnameArray[2] === "oversikt"
  ) {
    return sitePaths.ileggelser.oversikt.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 3 &&
    pathnameArray[1] === "ileggelser" &&
    pathnameArray[2] === "ettersendelser"
  ) {
    return sitePaths.ileggelser.ettersendelser.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 3 &&
    pathnameArray[1] === "ileggelser" &&
    pathnameArray[2] === "ettersendelser-til-godkjenning"
  ) {
    return sitePaths.ileggelser.ettersendelserTilGodkjenning.detalj.getUrl(id);
  } else if (
    pathnameArray[1] === "ileggelser" &&
    pathnameArray[2] === "elsparksykkel-gebyr"
  ) {
    return sitePaths.ileggelser.elsparksykkelGebyr.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 3 &&
    pathnameArray[1] === "miljogebyrer" &&
    pathnameArray[2] === "oversikt"
  ) {
    return sitePaths.miljogebyrer.oversikt.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 3 &&
    pathnameArray[1] === "miljogebyrer" &&
    pathnameArray[2] === "til-behandling"
  ) {
    return sitePaths.miljogebyrer.tilBehandling.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 5 &&
    pathnameArray[1] === "miljogebyrer" &&
    pathnameArray[2] === "miljokontrolloversikt" &&
    pathnameArray[3] === "miljogebyrer"
  ) {
    return sitePaths.miljogebyrer.miljokontrolloversikt.miljogebyrer.detalj.getUrl(
      id,
    );
  } else if (
    pathnameArray.length > 5 &&
    pathnameArray[1] === "miljogebyrer" &&
    pathnameArray[2] === "miljokontrolloversikt" &&
    pathnameArray[4] === "miljogebyrer"
  ) {
    return sitePaths.miljogebyrer.miljokontrolloversikt.detalj.miljogebyrer.detalj.getUrl(
      pathnameArray[3],
      id,
    );
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "ileggelser" &&
    pathnameArray[3] === "venter"
  ) {
    return sitePaths.innkreving.ileggelser.venter.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "ileggelser" &&
    pathnameArray[3] === "stoppet"
  ) {
    return sitePaths.innkreving.ileggelser.stoppet.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "ileggelser" &&
    pathnameArray[3] === "klar"
  ) {
    return sitePaths.innkreving.ileggelser.klar.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "ileggelser" &&
    pathnameArray[3] === "behandles-innkreving"
  ) {
    return sitePaths.innkreving.ileggelser.behandlesInnkreving.detalj.getUrl(
      id,
    );
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "ileggelser" &&
    pathnameArray[3] === "klar"
  ) {
    return sitePaths.innkreving.ileggelser.feilet.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "ileggelser" &&
    pathnameArray[3] === "feilet"
  ) {
    return sitePaths.innkreving.ileggelser.feilet.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "ileggelser" &&
    pathnameArray[3] === "vellykket"
  ) {
    return sitePaths.innkreving.ileggelser.vellykket.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "miljogebyr" &&
    pathnameArray[3] === "venter"
  ) {
    return sitePaths.innkreving.miljogebyr.venter.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "miljogebyr" &&
    pathnameArray[3] === "stoppet"
  ) {
    return sitePaths.innkreving.miljogebyr.stoppet.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "miljogebyr" &&
    pathnameArray[3] === "klar"
  ) {
    return sitePaths.innkreving.miljogebyr.klar.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "miljogebyr" &&
    pathnameArray[3] === "behandles-innkreving"
  ) {
    return sitePaths.innkreving.miljogebyr.behandlesInnkreving.detalj.getUrl(
      id,
    );
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "miljogebyr" &&
    pathnameArray[3] === "feilet"
  ) {
    return sitePaths.innkreving.miljogebyr.feilet.detalj.getUrl(id);
  } else if (
    pathnameArray.length > 4 &&
    pathnameArray[1] === "innkreving" &&
    pathnameArray[2] === "miljogebyr" &&
    pathnameArray[3] === "vellykket"
  ) {
    return sitePaths.innkreving.miljogebyr.vellykket.detalj.getUrl(id);
  }
  return undefined;
};

export default getSvarUtHistorikkCloseUrl;
